export interface ClientConfig {
  relativeUrls?: boolean;
  host?: Record<string, unknown>;
  defaultLocale?: string;
  auth?: { loginUrl?: string };
  urls?: Record<string, string>;
  [key: string]: unknown;
}

const config: ClientConfig = {
  relativeUrls: true,
  host: {},
  defaultLocale: 'sv',
  auth: {
    loginUrl: '/auth/login',
  },
  urls: {
    featuretoggle: '/foundation/featuretoggle',
    lists: '/foundation/lists',
    labels: '/foundation/labels',
    users: '/registry/users',
    menu: '/foundation/menu',
    reports: '/',
  },
};

export default config;
